<p-toast></p-toast>
<div class="p-grid form-group dashboard">
    <p-panel header="Filter" class="p-col-3 p-md-3 p-lg-3">
        <div class="p-grid form-group">
            <div class="p-col-12 p-md-12">
                <label for="startDate">Last Modified Date Between:</label>
            </div>

            <div class="p-col-12 p-md-6">
                <p-calendar id="startDate" placeholder="Start Date" [showButtonBar]="true" showTime="true"
                            hourFormat="24" [(ngModel)]="startDate" dateFormat="dd/mm/yy"></p-calendar>
            </div>
            <div class="p-col-12 p-md-6">
                <p-calendar id="endDate" placeholder="End Date" [showButtonBar]="true" showTime="true" hourFormat="24"
                            [(ngModel)]="endDate" dateFormat="dd/mm/yy"></p-calendar>
            </div>
            <div class="p-col-12 p-md-6">
                <button pButton type="button" label="Search" style="margin-bottom:10px" (click)="onSearch()"></button>
            </div>
        </div>
    </p-panel>

    <p-panel header="Downloads" class="p-col-3 p-md-3 p-lg-3">
        <div class="p-col-12 p-md-6">
            <button pButton type="button" label="Download Img+Json" style="margin-bottom:1px" (click)="onDownload()"></button>
        </div>
        <div class="p-col-12 p-md-6">
            <button pButton type="button" label="Download PDFs" style="margin-bottom:1px" (click)="downloadPdfs()"></button>
        </div>
        <div class="p-col-12 p-md-6">
            <button pButton type="button" label="Export CSV" style="margin-bottom:1px" (click)="exportPredictions()"></button>
        </div>
    </p-panel>

    <p-panel header="Stats" class="p-col-6 p-md-6 p-lg-6">
        <div class="p-grid">
            <div class="p-col-12 p-md-6 p-lg-6">
                <div class="overview-box  box-sales">
                    <div class="overview-box-icon">
                        <i class="pi pi-dollar"></i>
                    </div>
                    <div class="overview-box-title">Performance</div>
                    <div class="overview-box-value">{{successRate | number}} %</div>
                    <div class="overview-box-status"></div>
                </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
                <div class="overview-box  box-views">
                    <div class="overview-box-icon">
                        <i class="pi pi-search"></i>
                    </div>
                    <div class="overview-box-title">Processed Invoices</div>
                    <div class="overview-box-value">{{countInvoices}}</div>
                    <div class="overview-box-status"></div>
                </div>
            </div>
        </div>
    </p-panel>
</div>

<div class="ui-g">
    <div class="ui-g-12">
        <div class="card no-margin">

            <p-table #dt [columns]="cols" styleClass="ui-table-cars"
                     [value]="predictions"
                     [paginator]="true" [rows]="10" dataKey="id"
                     selectionMode="single" [(selection)]="selectedPrediction"
                     (onRowSelect)="editPrediction(selectedPrediction)"
                     (onRowUnselect)="onRowUnselect($event)"
                     [totalRecords]="totalRecords"
                     [lazy]="true" (onLazyLoad)="loadPredictions($event)"
                     [loading]="loading">
                <ng-template pTemplate="caption">
                    List of Predictions
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngSwitch]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                    <tr>
                        <th *ngFor="let col of columns" [ngSwitch]="col.field" style="padding: .5em;">
                            <input *ngSwitchCase="'id'" pInputText type="text" placeholder="Equals"
                                   class="ui-column-filter" style="width: 100%; margin-top: 0;"
                                   (input)="dt.filter($event.target.value, col.field, 'equals')">
                            <input *ngSwitchCase="'invoiceId'" pInputText type="text" placeholder="Contains"
                                   class="ui-column-filter" style="width: 100%; margin-top: 0;"
                                   (input)="dt.filter($event.target.value, col.field, 'contains')">
                            <input *ngSwitchCase="'iceSupplierPredictedByIceExtractor'" pInputText type="text"
                                   placeholder="Contains" class="ui-column-filter" style="width: 100%; margin-top: 0;"
                                   (input)="dt.filter($event.target.value, col.field, 'contains')">
                            <input *ngSwitchCase="'fiscalIdPredictedByExtractor'" pInputText type="text"
                                   placeholder="Contains" class="ui-column-filter" style="width: 100%; margin-top: 0;"
                                   (input)="dt.filter($event.target.value, col.field, 'contains')">
                            <input *ngSwitchCase="'supplierTaxIdPredictedByExtractor'" pInputText type="text"
                                   placeholder="Contains" class="ui-column-filter" style="width: 100%; margin-top: 0;"
                                   (input)="dt.filter($event.target.value, col.field, 'contains')">
                            <p-dropdown *ngSwitchCase="'iceExtractorStatus'" [options]="statusesIce"
                                        (onChange)="dt.filter($event.value, 'iceExtractorStatus', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select a Status" [showClear]="true">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                            <p-dropdown *ngSwitchCase="'deskewingInvoiceStatus'" [options]="statusesDesk"
                                        (onChange)="dt.filter($event.value, 'deskewingInvoiceStatus', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select a Status" [showClear]="true">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                            <p-dropdown *ngSwitchCase="'milouBlockStatus'" [options]="statuses"
                                        (onChange)="dt.filter($event.value, 'milouBlockStatus', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select a Status" [showClear]="true">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                            <p-dropdown *ngSwitchCase="'voterStatus'" [options]="statuses"
                                        (onChange)="dt.filter($event.value, 'voterStatus', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select a Status" [showClear]="true">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                            <p-dropdown *ngSwitchCase="'invoiceStatus'" [options]="statuses"
                                        (onChange)="dt.filter($event.value, 'invoiceStatus', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select a Status" [showClear]="true">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                            <p-dropdown *ngSwitchCase="'processed'" [options]="yesOrNo"
                                        (onChange)="dt.filter($event.value, 'processed', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select a Status" [showClear]="true">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData" [pEditableRow]="rowData">
                        <td>{{rowData.id}}</td>
                        <td>{{rowData.invoiceId}}</td>
                        <td>{{rowData.iceSupplierPredictedByIceExtractor}}</td>
                        <td>{{rowData.fiscalIdPredictedByExtractor}}</td>
                        <td>{{rowData.supplierTaxIdPredictedByExtractor}}</td>
                        <td>{{rowData.iceExtractorStatus}}</td>
                        <td>{{rowData.deskewingInvoiceStatus}}</td>
                        <td>{{rowData.milouBlockStatus}}</td>
                        <td>{{rowData.voterStatus}}</td>
                        <td>{{rowData.invoiceStatus}}</td>
                        <td>{{rowData.processed}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        In total there are {{ totalRecords }} predictions.
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<p-dialog [(visible)]="predictionDialog" [style]="{width: '650px', height: '600px' }"
          header="{{prediction.id?'Editing':'Adding'}} the Prediction" [modal]="true">
    <div class="p-grid form-group">
        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="id">Id</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input type="text" id="id" pInputText placeholder="Supplier ICE" [(ngModel)]="prediction.id" disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="invoiceId">Invoice ID</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="invoiceId" type="text" pInputText placeholder="Invoice  ID"
                       [(ngModel)]="prediction.invoiceId" disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="invoiceOcr">Invoice OCR</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="invoiceOcr" type="text" pInputText placeholder="Invoice  OCR"
                       [(ngModel)]="prediction.invoiceOcr" disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="lastModified">Modification Date</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="lastModified" type="text" pInputText placeholder="Modification Date"
                       [(ngModel)]="prediction.lastModified" disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="iceExtractorStatus">ICE Extractor Status</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="iceExtractorStatus" type="text" pInputText placeholder="ICE Extractor Status"
                       [(ngModel)]="prediction.iceExtractorStatus" disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="iceSupplierPredictedByIceExtractor">Predicated Supplier ICE</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="iceSupplierPredictedByIceExtractor" type="text" pInputText
                       placeholder="Predicated Supplier ICE" [(ngModel)]="prediction.iceSupplierPredictedByIceExtractor"
                       disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="deskewingInvoiceStatus">Deskewing Invoice Status</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="deskewingInvoiceStatus" type="text" pInputText placeholder="Deskewing Invoice Status"
                       [(ngModel)]="prediction.deskewingInvoiceStatus" disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="deskewingInvoiceStatus">Milou Block Status</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="milouBlockStatus" type="text" pInputText placeholder="Milou Block Status"
                       [(ngModel)]="prediction.milouBlockStatus" disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="voterStatus">Voter Status</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="voterStatus" type="text" pInputText placeholder="Voter Status"
                       [(ngModel)]="prediction.voterStatus" disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="processed">Processed</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="processed" type="text" pInputText placeholder="Processed" [(ngModel)]="prediction.processed"
                       disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="invoiceStatus">Invoice Status</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="invoiceStatus" type="text" pInputText placeholder="Invoice Status"
                       [(ngModel)]="prediction.invoiceStatus" disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="imageUrl">Image Url</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="imageUrl" type="text" pInputText placeholder="Image Url" [(ngModel)]="prediction.imageUrl"
                       disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="fileName">File Name</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="fileName" type="text" pInputText placeholder="File Name" [(ngModel)]="prediction.fileName"
                       disabled>
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="p-col-12">
                <label for="fileName">Supplier Tax Id</label>
            </div>
            <div class="p-col-12" style="margin-bottom:10px">
                <input id="supplierTaxId" type="text" pInputText placeholder="File Name" [(ngModel)]="prediction.supplierTaxIdPredictedByExtractor"
                       disabled>
            </div>
        </div>
    </div>
</p-dialog>

<p-confirmDialog [style]="{width: '500px'}"></p-confirmDialog>
